
import React from 'react'
import { Card, Row, Col, Menu, Switch } from 'antd';
import { 
	EyeOutlined, 
	EditOutlined,
	DeleteOutlined } from '@ant-design/icons';
import EllipsisDropdown from 'components/shared-components/SettingsDropdown'
import Flex from 'components/shared-components/Flex';
import {BLOB_STORAGE_URL} from 'constants/ApiConstant';
import 'font-awesome/css/font-awesome.css'
import { t } from "i18next";

    const ItemAction = ({app,edit, preview,deletePage,toggle}) => {
        const permissions  = localStorage.getItem("permissions")!==""?JSON.parse(localStorage.getItem("permissions")):"";
        return(
<div className="flex flex-col h-full">
    <div className="flex-grow">        {permissions?.allpermissions || permissions[`subscribe_${app?.type}`] ? (
            <EllipsisDropdown 
                menu={
                    <Menu>
                        <Menu.Item key="0" onClick={() => edit(app)}>
                            <EditOutlined />
                            <span className="ml-2">{t("impaqx.adminApp.edit")}</span>
                        </Menu.Item>
                        <Menu.Item key="1" onClick={() => preview(app)}>
                            <EyeOutlined />
                            <span className="ml-2">{t("impaqx.adminApp.preview")}</span>
                        </Menu.Item>
                        <Menu.Divider />
                        <Menu.Item key="2" onClick={() => deletePage(app)}>
                            <DeleteOutlined />
                            <span className="ml-2">{t("impaqx.adminApp.delete")}</span>
                        </Menu.Item>
                    </Menu>
                }
            />
        ) : null}
        </div>
        <Switch checked={app?.status === "ACTIVE"} onChange={(e) => toggle(e, app)} />
    </div>
    )
    }
    
    const ItemHeader = ({app,showMore}) => {
        return(
        <div style={{minHeight:'300px'}}>
            <h4 className="mb-2" style={{wordBreak:'break-all'}}> {app.pageName} </h4>
            <div  className="mb-0" style={{wordBreak:'break-all'}}
           dangerouslySetInnerHTML={{__html : (app?.description?.length > 440 ) ? app?.description?.substring ( 0 , 440 - 1 ).concat ( "…" ) : app?.description?app?.description:""}}></div>
           {app?.description?.length > 250?<a className="btn btn-primary" onClick={()=>showMore(app)}>{t("impaqx.adminApp.showMore")}</a>:null}
            <span className="text-muted">{app.category}</span>
        </div>)
    }

const GridItem = ({data,edit, preview,deletePage,showMore,toggle}) => (<>
	<Card style={{height:'100%'}}>
		<Flex className='flex-lg-row flex-column custom-grid' justifyContent="between">
        <div className="d-flex align-items-baseline ant-col ant-col-xs-24 ant-col-sm-24 ant-col-lg-24 ant-col-xl-5">
        <div className='productImg'>
          <img style={{width: '100%'}} src={data.previewImage} 
               onError={(e) => {
                e.target.src = `${BLOB_STORAGE_URL}/extremeb2b/appLogo/noimage.jpg`
                e.target.style = 'width: 100%'
             }} 
             alt={data.previewImage}/>
        </div>
        </div>
		<Flex alignItems="center" justifyContent="between">
			<ItemHeader  app={data} showMore={showMore}/>
            <ItemAction  app={data} edit={edit} preview={preview}  deletePage={deletePage} toggle={toggle}/>
            </Flex>
        </Flex>
	</Card>
    </>
)

const ListGridView =(props)=>{
 const { templatePagesDrafts,edit,deletePage,preview,showMore,toggle} = props;
    return(
    <div className="my-4 container-fluid" style={{width:"100%"}}>
					<Row gutter={16}>
						{templatePagesDrafts?.map(elm => (
							<Col xs={24} sm={24} md={12} lg={12} xl={8} xxl={8} className="mb-3"  key={elm.id}>
								<GridItem  data={elm} edit={edit} deletePage={id => deletePage(id)} showMore={showMore} preview={preview} toggle={toggle} />
							</Col>
						))}
					</Row>
			</div>
    )
}

export default ListGridView;
